import CartSettingsContainer from './CartSettingsContainer';
export default CartSettingsContainer;
